import { Component, OnInit, ViewChild,ElementRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { FormMode, Languages, ServiceStatus,TransitConfirmVesselTransitDecision } from 'src/app/shared/models/enums.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { TransitAdminDto,ConfirmVesselTransit } from '../../shared/models/transit-admin.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { DatePipe } from '@angular/common';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';

@Component({
  selector: 'app-confirm-Vessel-Transit',
  templateUrl: './confirm-Vessel-Transit.component.html',
})
export class confirmVesselTransitComponent implements OnInit {

  @ViewChild('transitRequest',{static: false}) transitRequest: TransitRequestComponent;
  @ViewChild ('confirmVesselTransitControls',{static: false}) confirmVesselTransitControls: ElementRef;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  displayedLang: Languages;
  decision = TransitConfirmVesselTransitDecision;
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  private submitconfirmVesselTransitFormResponseObject: ResponseObject = new ResponseObject();
  private submitconfirmVesselTransitFormObject: ConfirmVesselTransit = new ConfirmVesselTransit();
  private getconfirmVesselTransitFormResponseObject: ResponseObject = new ResponseObject();
  private getconfirmVesselTransitFormObject: ConfirmVesselTransit;
  transitRequestId: string;
  responseObj: ResponseObject = new ResponseObject();
  showRequest: boolean = false;
  securityLevels: GenericLookup[] = [];
  baseRequestId: string = '';
  requestStatus: number;
  private confirmVesselTransitForm: FormGroup;
  baseRequestDTO: BaseRequest// = new BaseRequest();
  user: User = new User();
  submitted = false;

  public isRequestSucceeded: boolean = false;


  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private transitSrv: TransitService,
    private lookupService: LookupService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.displayedLang = this.globalSrv.getLanguage()
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    if (history.state.data && history.state.data.requestId) {

      this.baseRequestId = history.state.data.requestId;
    }
    else{
      window.history.back();
    }
    this.user = this.globalSrv.user;
  }
  ngOnInit() {
   // this.globalSrv.isLoaderEnabled = true;
    if (this.baseRequestId) {
      this.getTransitRequest();
     // this.GetConfirmVesselTrasitData();
    }
    this.buildForm(null);
  }
  buildForm(decision): void {
    this.confirmVesselTransitForm = this.formBuilder.group({
      Decision: ['', Validators.required],
    });
    if (decision == TransitConfirmVesselTransitDecision.CANCEL_VesselTRANSIT) {
      this.confirmVesselTransitForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Notes: ['', Validators.required],
      });
    } else if (decision == TransitConfirmVesselTransitDecision.CONFIRM_VesselTRANSIT) {
      this.confirmVesselTransitForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Notes: ['', Validators.required],
        TransitDate: ['', [Validators.required]]
      });
    }
  }

  get f() {
    return this.confirmVesselTransitForm.controls;
  }
  changeDecision(value) {
    this.buildForm(value);
    this.confirmVesselTransitForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;

  }

  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitRequestId = resObj.Data['Id'];
          let decision = resObj.Data['IsVesselTransited']
          if(decision){
            this.changeDecision(1);
            this.confirmVesselTransitForm.patchValue({

              Notes:resObj.Data['ConfirmTransitNote'],
              TransitDate:resObj.Data['ActualTransitDate'],
            });

          }
          else if(!decision){
            this.changeDecision(2);
            this.confirmVesselTransitForm.patchValue({

              Notes:resObj.Data['ConfirmTransitNote'],
            });
          }
          else
          {

          }


        }
      });
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }
  submit(): void {
    this.submitted = true;
    const inValidControls = this.confirmVesselTransitControls.nativeElement.querySelectorAll('.ng-invalid');
    if(inValidControls.length > 0) {
      inValidControls[0].focus();
    } else {

      this.globalSrv.isLoaderEnabled = true;
      this.submitconfirmVesselTransitFormObject.ID=this.transitRequestId;
      if(this.decisionValue==TransitConfirmVesselTransitDecision.CONFIRM_VesselTRANSIT){
      this.submitconfirmVesselTransitFormObject.decision = this.decisionValue;
      this.submitconfirmVesselTransitFormObject.Note = this.confirmVesselTransitForm.controls.Notes.value;
      this.submitconfirmVesselTransitFormObject.Date = this.datePipe.transform(this.confirmVesselTransitForm.controls.TransitDate.value, "yyyy-MM-dd");
      }
      else{
      this.submitconfirmVesselTransitFormObject.decision = this.decisionValue;
      this.submitconfirmVesselTransitFormObject.Note = this.confirmVesselTransitForm.controls.Notes.value;
      }

       this.submitconfirmVesselTransitForm();

    }
  }

  submitconfirmVesselTransitForm(): void {
    this.transitSrv.AddConfirmVesselTransit(this.submitconfirmVesselTransitFormObject).subscribe(
      data => this.submitconfirmVesselTransitFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitconfirmVesselTransitFormCompleted()
    );
  }
  submitconfirmVesselTransitFormCompleted(): void {
    if(!this.submitconfirmVesselTransitFormResponseObject.Success) {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalSrv.isLoaderEnabled = false;

    this.toastr.success('Data Saved Successfully', 'Success!');
  }
}


enum ConfirmationMode {
  Success  = 1,
  Error = 2
}
